export const PLACEHOLDER_STYLE = {
    opacity: 0.7,
    color: 'hsl(220, 20%, 42%)',
};

